import { Merge } from 'type-fest'

import { DipsSchemas } from '~/clients/dips-client'

export type DipsResource = DipsSchemas['ResourceDtoV2']
export type UnifiedDipsResource = Merge<{ entity_type: 'dips_resource' }, DipsResource>

export function transformDipsResources(resources: DipsResource[]): UnifiedDipsResource[] {
    return resources.map(resource => ({
        ...resource,
        entity_type: 'dips_resource',
    }))
}
